
"use client";

import BaseModal from "../common/BaseModal";
import TextInput from "../input/TextInput";
import {useContext, useEffect, useState} from "react";
import DefaultButton from "../buttons/DefaultButton";
import NumberInput from "../input/NumberInput";
import {useAuth} from "../../providers/authProvider";
import {ApiContext} from "../contexts/ApiContext";
import {ValidationContext} from "../contexts/ValidationContext";
import CheckBoxInput from "../input/CheckBoxInput";

function EditHomeVisitCategoryModal(
    props: {
        openModal: boolean,
        setOpenModal: (arg: boolean) => void,
        categoryInfo: any
    }
) {
    const { token } = useAuth();
    const { Url } = useContext(ApiContext)
    const [name, setName] = useState('')
    const [salesPrice, setSalesPrice] = useState('')
    const [ledgerId, setLedgerId] = useState('')
    const [categoryPublic, setCategoryPublic] = useState(false)
    const [message, setMessage] = useState('')
    const {nameRegex, nameErrorMessage} = useContext(ValidationContext)

    useEffect(() => {
        if (props.categoryInfo) {
            setName(props.categoryInfo.Name);
            setSalesPrice(props.categoryInfo.SalesPrice.toString());
            setLedgerId(props.categoryInfo.LedgerId ? props.categoryInfo.LedgerId.toString() : '');
            setCategoryPublic(props.categoryInfo.Public);
        }
        setMessage('')
    }, [props.categoryInfo, props.openModal]);

    function editPresentCategory(event: React.FormEvent) {
        event.preventDefault()
        fetch(Url + 'admin/home-visit-categories', {
            method: 'PATCH',
            headers: {
                'content-type': 'application/json',
                'Authorization': "Bearer " + token,
            },
            body: JSON.stringify({
                ID: props.categoryInfo.ID,
                Name: name,
                SalesPrice: salesPrice,
                LedgerId: parseInt(ledgerId) || 0,
                Public: categoryPublic,
            }),
        })
            .then((res) => {
                return res.json()
            })
            .then((data) => {
                setMessage(data.message)
            })
    }

    return (
        <BaseModal
            show={props.openModal}
            onClose={() => props.setOpenModal(false)}
            title="Huisbezoek categorie bewerken"
            footer={
                <>
                    <DefaultButton onClick={editPresentCategory} content="Opslaan"/>
                    <DefaultButton onClick={() => props.setOpenModal(false)} content="Sluiten"/>
                </>
            }
        >
            <p className="text-base leading-relaxed text-gray-500">
                Pas de naam van de categorie en de verkoopprijs aan en klik op opslaan.
            </p>
            <p className="text-base leading-relaxed text-red-500">
                {message}
            </p>
            <TextInput
                labelName="Naam"
                inputName="name"
                onChange={(e) => setName(e.target.value)}
                value={name}
                placeholder="Naam"
                errorMessage={nameErrorMessage}
                pattern={nameRegex}
                type="text"
            />
            <NumberInput
                labelName="Verkoopprijs"
                inputName="salesPrice"
                onChange={(e) => setSalesPrice(e.target.value)}
                value={salesPrice}
                placeholder="Prijs in euros"
                errorMessage="Vul hier het bedrag in euro's in. Gebruik alleen getallen."
                min={0}
                step="0.01"
                max={undefined}
            />
            <NumberInput
                labelName="Ledger ID (E-boekhouden)"
                inputName="ledgerId"
                onChange={(e) => setLedgerId(e.target.value)}
                value={ledgerId}
                placeholder="Ledger ID"
                errorMessage="Vul hier het Ledger ID in."
                min={0}
                step="1"
                max={undefined}
            />
            <CheckBoxInput
                labelName="Publiek (zichtbaar in het aanvraagformulier voor klanten)"
                inputName="public"
                checked={categoryPublic}
                setChecked={setCategoryPublic}
            />
        </BaseModal>
    );
}
export default EditHomeVisitCategoryModal
